import { styled } from '@mui/material';
import { Home } from '@mui/icons-material';

export const BreadcrumbItem = styled('a')({
  cursor: 'pointer',
  '&:not(:first-of-type)::before': {
    content: '"/"',
    margin: '12px',
  },
});

export const HomeButton = styled(Home)({
  cursor: 'pointer',
  marginBottom: '4px',
});
